const Button = (props) => {
  return <button type="button" {...props} />;
};

export default Button;
